import React, { useEffect } from 'react';
import CreditApplicationTemplateTable from './CreditApplicationTemplateTable';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getCreditApplicationTemplates } from '../../../../redux/services/creditApplicationsTemplatesService';
import { getCurrentSupplier } from '../../../../redux/services/authService';

const CreditApplicationTemplates = () => {
  const dispatch = useAppDispatch();
  const { creditApplicationTemplates } = useAppSelector(
    (state) => state.creditApplicationTemplates
  );
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (!currentSupplier?.id) return;
    dispatch(
      getCreditApplicationTemplates({
        supplierId: currentSupplier?.id ?? '',
        applicationType: 'ALL',
      })
    );
    dispatch(getCurrentSupplier({ supplierId: currentSupplier.id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, currentSupplier?.id]);

  return (
    <div className="h-full p-4 flex ">
      <CreditApplicationTemplateTable creditApplicationTemplates={creditApplicationTemplates} />
    </div>
  );
};

export default CreditApplicationTemplates;
